import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { WecomMsOrgCallbackPage } from "@ms/shared-auth";

/**
 * 换票成功后回首页；失败时落到单店页（与历史行为一致，便于用户看到错误后重试）。
 */
const WecomCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  return (
    <WecomMsOrgCallbackPage
      navigate={navigate}
      searchParams={searchParams}
      afterLoginNavigateTo="/"
      onErrorNavigateTo="/store-revenue-single"
    />
  );
};

export default WecomCallbackPage;
